<script setup lang="ts">
// https://image.nuxt.com/usage/nuxt-img
import { getImageStubSrc } from '~/utils/image-utils'

defineProps<{
  alt: string | undefined
  src: string
  width: number
  height: number
  preset: 'detail-page-image' // will extend once the gallery is built
}>()
</script>

<template>
  <NuxtImg
    :placeholder="[width, height]"
    :src="src || getImageStubSrc()"
    :alt="alt"
    :width="width"
    :height="height"
    :preset="preset"
    loading="lazy"
  />
</template>
